export default __webpack_public_path__ + "static/media/1.730b2722.png";